@use '@/styles/tokens' as *;

/* Figma 864:558218 — an 8px mark beside the metric's value. The healthy mark is reproduced exactly
 * (`<circle r=3.5 fill=#19A974 stroke=#B7EA8B/>` in an 8x8 box); the other two have no frame (M8)
 * and are built from the shipped warning/error tokens per grilling Q11.
 *
 * Shape, not just colour: `clip-path` gives each state an outline nobody has to interpret a hue to
 * tell apart, which is what makes 113588 §7e hold without a hover affordance. */

$mark-size: 8px;

.indicator {
  display: inline-flex;
  flex: none;
  align-items: center;
}

.mark {
  display: block;
  width: $mark-size;
  height: $mark-size;
}

.healthy {
  background: $color-success-700;
  /* A 1px ring, as drawn — `box-sizing: border-box` keeps the mark 8px overall, matching the SVG's
   * 8x8 viewBox rather than growing to 10. */
  box-sizing: border-box;
  border: 1px solid $color-brand-400;
  border-radius: 50%;
}

.warning {
  background: $color-warning-700;
  clip-path: polygon(50% 0%, 100% 100%, 0% 100%);
}

.critical {
  background: $color-error-700;
  clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
}

/* Not `display: none` — the state must reach a screen reader. */
.state {
  @include visually-hidden;
}
